import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    minHeight: "calc(100vh - 350px)",
    padding: theme.spacing(2),
  },
  icon: {
    width: 48,
    height: 48,
    marginBottom: theme.spacing(2),
  },
  text: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.25,
    letterSpacing: "0.25px",
    color: "rgba(26, 26, 26, 0.6)",
  },
}));
